import { render, staticRenderFns } from "./newUserEbook.vue?vue&type=template&id=271ab62c&"
import script from "./newUserEbook.vue?vue&type=script&lang=js&"
export * from "./newUserEbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports